// Log a Return button (GW-471) — injects a "Log a return" button into the
// storefront's order-history rows and the order-detail page.
//
// Placement is marker-driven (the storefront owns those pages): the template
// adds a mount point where a button should go —
//     <span data-pf-log-return data-order="ORD1000151"></span>
// on each order-history row's action cell (next to the view-order icon) and on
// the order-detail header. IMPORTANT: only add the marker for PAID + COMPLETED
// orders (the storefront knows the order status). This embed then decides
// *eligibility by window*: it asks the parts-finder which of the account's
// paid+completed orders are still within the return window and renders an active
// button for those, or a greyed/disabled button for ones past the window.
//
// The button links to the SPA form with the order pre-selected:
//   /parts-finder?view=log-return&order=<orderRef>
import { apiJson } from '../shared/api.js';
import { getTopDocument } from '../shared/dom.js';

export var id = 'log-return-button';

function readCookie(name) {
  try {
    var doc = getTopDocument();
    var match = (doc.cookie || '')
      .split(';')
      .map(function (c) { return c.trim(); })
      .filter(function (c) { return c.indexOf(name + '=') === 0; })[0];
    return match ? decodeURIComponent(match.slice(name.length + 1)) : '';
  } catch (e) { return ''; }
}

function sessionHeaders() {
  var h = {};
  var jwt = readCookie('commerce_features');
  if (jwt) h['X-Commerce-Features'] = jwt;
  var sr = readCookie('Session');
  if (sr) h['X-Session-Reference'] = sr;
  return h;
}

// Where the button links to. Defaults to the SPA route, but GW will typically
// point it at a dedicated storefront CORE page hosting the form embed widget —
// set it per-marker with data-target="/log-a-return" or globally via
// window.__PF_LOG_RETURN_URL__ = '/log-a-return'. The order ref is appended as
// ?order=<ref> (the form embed reads it off the page URL).
function returnTarget(marker) {
  var t = (marker.getAttribute('data-target') || '').trim();
  if (t) return t;
  try { if (window.__PF_LOG_RETURN_URL__) return String(window.__PF_LOG_RETURN_URL__); } catch (e) { /* ignore */ }
  return '/parts-finder?view=log-return';
}

function renderButton(marker, orderRef, enabled) {
  var doc = getTopDocument();
  var base =
    'display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;' +
    'padding:6px 12px;border-radius:8px;text-decoration:none;line-height:1;white-space:nowrap;';
  if (enabled) {
    var target = returnTarget(marker);
    var a = doc.createElement('a');
    a.className = 'pf-log-return-btn';
    a.href = target + (target.indexOf('?') === -1 ? '?' : '&') + 'order=' + encodeURIComponent(orderRef);
    a.style.cssText = base + 'color:#fff;background:#e67e22;border:1px solid #e67e22;cursor:pointer;';
    a.innerHTML =
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14l6-6m-4.5-1.5L15 3l3 3-4.5 4.5m-6 6L3 21l3-3"/></svg>' +
      '<span>Log a return</span>';
    marker.appendChild(a);
  } else {
    var b = doc.createElement('span');
    b.className = 'pf-log-return-btn pf-log-return-disabled';
    b.title = 'The return window for this order has closed';
    b.style.cssText = base + 'color:#9ca3af;background:#f3f4f6;border:1px solid #e5e7eb;cursor:not-allowed;';
    b.innerHTML = '<span>Return window closed</span>';
    marker.appendChild(b);
  }
}

export function init() {
  var doc = getTopDocument();
  var markers = doc.querySelectorAll('[data-pf-log-return]');
  if (!markers || markers.length === 0) return;

  // Which of the account's paid+completed orders are still in-window.
  apiJson('/api/returns/orders', { headers: sessionHeaders() }, null).then(function (data) {
    var orders = (data && data.orders) || [];
    var eligible = {};
    for (var i = 0; i < orders.length; i++) {
      var o = orders[i];
      var ref = o.orderRef || o.orderNumber || o.orderId;
      if (o.orderNumber) eligible[String(o.orderNumber)] = ref;
      if (o.orderRef) eligible[String(o.orderRef)] = ref;
      if (o.orderId) eligible[String(o.orderId)] = ref;
    }
    Array.prototype.forEach.call(markers, function (m) {
      if (m.getAttribute('data-pf-return-rendered')) return;
      m.setAttribute('data-pf-return-rendered', '1');
      var key = (m.getAttribute('data-order') || '').trim();
      if (!key) return;
      var ref = eligible[String(key)];
      renderButton(m, ref || key, !!ref);
    });
  });
}
